var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('input',{staticClass:"all-check",attrs:{"type":"checkbox"},on:{"change":_vm.checkAll}}),_vm._v(" "+_vm._s(_vm.getTranslation('b056')))]),_c('Tree',{key:_vm.selectionVersion,staticClass:"tree-render",attrs:{"data":_vm.plData,"render":_vm.renderPlContent,"empty-text":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }